module.exports = __webpack_public_path__ + "img/countdown.8f891c04.gif";